export const AUTH_STORE_KEY = 'pdf2convert_auth';
